<template>
	<div class="forgot-password">
		<GuestLayout class="box">
			<form @submit.prevent="sendResetLink()" slot="guest-body" class="guest-body">
				<span class="information">
					Enter your email so we can send your password reset link
				</span>

				<span class="success" v-if="forgotPasswordMessage === 'success'">
					The reset link has been sent! Please check your email.
				</span>

				<InputField
					type="email"
					class="input-line"
					label="Email"
					placeholder="Enter email here"
					v-model="email"
				/>

				<p class="_error" v-if="forgotPasswordMessage && forgotPasswordMessage !== 'success'">
					{{ forgotPasswordMessage }}
				</p>

				<div class="controls">
					<button class="_primary" type="submit" :disabled="loading">
						{{ loading ? 'Loading...' : 'Send reset link' }}
					</button>

					<router-link to="/">
						Remember your password? Sign in
					</router-link>
				</div>
			</form>
		</GuestLayout>
	</div>
</template>
<script>
import { mapFields } from 'vuex-map-fields'
import InputField from '@/components/utils/InputField.vue'
import GuestLayout from '@/components/layouts/GuestLayout.vue'

export default {
	computed: {
		...mapFields('auth', [
			'email',
			'forgotPasswordMessage',
			'loading'
        ]),
	},

	components: {
		InputField,
		GuestLayout
	},

	destroyed () {
		this.$store.commit('auth/clearAuth')
	},

	methods: {
		sendResetLink () {
			let form = new FormData()

			form.append('email', this.email)
			form.append('language', 'english')
			this.$store.dispatch('auth/forgotPassword', form)
		}
	}
}
</script>
<style lang="scss" scoped>
.forgot-password {
	width: 100%;
	height: 100%;

	.guest-body {
		span {
			display: block;
			margin-bottom: 15px;
			font-size: 16px;
			text-align: center;
		}

		.information {
			color: #575B5C;
		}

		.success {
			color: #3DBFCD;
		}

		.input-line {
			margin-top: 70px;
		}

		.controls {
			display: flex;
			flex-direction: column;
			align-items: center;

			button {
				margin: 45px 0 25px 0;
				width: auto;
			}

			a{
				color: #3DBFCD;
				font-size: 18px;
				margin-bottom: 25px;

				&:hover {
					color: darken(#3DBFCD,10%);
				}
			}
		}
	}
}
</style>
